import { render, staticRenderFns } from "./RecycleLabel.vue?vue&type=template&id=186876f5"
import script from "./RecycleLabel.vue?vue&type=script&lang=js"
export * from "./RecycleLabel.vue?vue&type=script&lang=js"
import style0 from "./RecycleLabel.vue?vue&type=style&index=0&id=186876f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports